<div class="ipm-equalizer-container" [class.ipm-anima-hover]="isShowHover" [class.ipm-anima-added]="!isShowHover">
    <div class="ipm-bar"></div>
    <div class="ipm-bar"></div>
    <div class="ipm-bar"></div>
  </div>